/* istanbul ignore file */

//TODO: fix test coverage
import { v4 as uuidv4 } from 'uuid';

import type { RegistrationForm } from 'src/types/registration';
import { apiCall, authenticatedApiCall } from 'src/utils/apiCall/apiCall';

// TODO: reimplement using ramda
const removeFields = (formData: RegistrationForm, omitFields: string[]) => {
  const clone = {};

  for (const key in formData) {
    if (!omitFields.includes(key)) {
      const field = formData[key];

      clone[key] =
        Array.isArray(field) && field.length && typeof field[0] === 'object'
          ? field.map((obj) => removeFields(obj, omitFields))
          : field;
    }
  }
  return clone;
};

const removeEmptyProducts = (formData: RegistrationForm) => {
  const products = formData.products.filter((product) => !!product.productName);
  return { ...formData, products };
};

export const submitOnboardingApplication = async (formData: RegistrationForm) =>
  authenticatedApiCall({
    url: '/applications',
    method: 'POST',
    data: removeFields(removeEmptyProducts(formData), ['id', 'attachmentType', 'attachmentId']),
  });

export const submitPartnerEmail = async (email: string) =>
  apiCall({ url: '/interests', method: 'POST', data: { email } });

export const initialFormData: RegistrationForm = {
  companyName: '',
  registrationType: '',
  address: { country: '', addressLine1: '', addressLine2: '', addressTown: '', postcode: '' },
  telephone: { dialingCode: '', telephone: '' },
  partnerSource: '',
  partnerInvited: false,
  partnerAgreesToProvideId: false,
  website: '',
  instagramHandle: '',
  socialMedia: [{ url: '', id: uuidv4() }],
  leadinTime: '',
  salesChannels: {
    supermarkets: {
      uses: false,
      storesUsed: [],
    },
    onlineStores: {
      uses: false,
      storesUsed: [],
    },
    highstreetStores: {
      uses: false,
      storesUsed: [],
    },
    boutiques: {
      uses: false,
    },
  },
  deliverAreas: {
    selfDeliveryAreas: '',
  },
  packagingAttachments: [],
  pipelinePlans: {
    details: '',
  },
  productCategories: [],
  certification: { required: '', attachments: [] },
  products: [
    {
      productName: '',
      url: '',
      id: uuidv4(),
    },
    {
      productName: '',
      url: '',
      id: uuidv4(),
    },
    {
      productName: '',
      url: '',
      id: uuidv4(),
    },
  ],
};
